<template>
    <div
        class="conversation-item"
        :class="{
            active: isActive(),
            ghost: isGhost(),
            unreaded: getUnreadCount(),
        }"
        @click="clickConversation"
    >
        <div class="minimize-card-detail" v-if="!isGhost()">
            <div class="conversation-contact-avatar">
                <ContactAvatar :contact="contact" :badge="true" :size="'small'" />
                <div class="contact-platform">
                    <PlatformIcon :platform="contact.platform" :size="15" />
                </div>
            </div>
            <div class="contact-detail">
                <div class="contact-detail-head">
                    <div
                        class="contact-information"
                        v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
                        :content="getFullname()"
                    >
                        {{ getFullname() }}
                    </div>
                    <div
                        class="contacted-date"
                        v-if="contact"
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="getFullTime()"
                    >
                        <div :key="dateRenderKey" class="time-label">
                            <i
                                class="material-icons"
                                v-if="contactListSortMode.startsWith('chat.create') && !isClosedChat(contact)"
                            >
                                hourglass_top
                            </i>
                            <i class="material-icons" v-else> watch_later </i>
                            {{ fromNow() }}
                        </div>
                    </div>
                </div>
                <div class="contact-detail-content">
                    <div class="contact-detail-content-message">
                        <div class="icon-wrapper">
                            <div class="material-icons" v-if="getLastMessageSender() === 'visitor'">person</div>
                            <div class="material-icons" v-if="getLastMessageSender() === 'user'">support_agent</div>
                        </div>
                        <div v-if="lastMessageIsAsset()" class="contact-last-message media">
                            Media
                            <div class="material-icons">attach_file</div>
                        </div>
                        <div v-else-if="lastMessageIsLocation()" class="contact-last-message media">
                            Location
                            <div class="material-icons">location_on</div>
                        </div>
                        <div
                            v-else
                            class="contact-last-message"
                            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
                            :content="getLastMessage()"
                        >
                            {{ getLastMessage() }}
                        </div>
                    </div>
                    <div class="unread-badge" v-if="getUnreadCount()">{{ getUnreadCount() }}</div>
                </div>
                <div
                    class="chat-owner-text"
                    :class="{
                        [getChatOwnerStatus()]: true,
                    }"
                >
                    {{ getChatOwnerText() }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import WhatsappIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import { SanitizeHtml } from "../../../utils/utils";
import MessengerIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";
import ContactAvatar from "./ContactAvatar.vue";
import { mapGetters, mapState } from "vuex";
import WhatsappSvg from "./svg/WhatsappSvg.vue";
import BrowserSvg2 from "./svg/Browser2Svg.vue";
import moment from "moment";
import PlatformIcon from "./ChatMessageArea/components/PlatformIcon.vue";
import _ from "lodash";

export default {
    name: "GridContactListItem",
    components: { PlatformIcon, BrowserSvg2, WhatsappSvg, ContactAvatar, MessengerIcon, WhatsappIcon },
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
        activeContact: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        dateRenderKey: null,
        dateInterval: null,
    }),
    mounted() {
        this.setupInterval();
    },
    computed: {
        ...mapState({
            lookedChats: (state) => state.chat.lookedConversationIds,
            watchingContactIds: (state) => state.chat.watchingContactIds,
            contactListSortMode: (state) => state.chat.contactListSortMode,
            liveVisitors: (state) => state.visitor.liveVisitors,
            users: (state) => state.user.users.data,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({
            findConversation: "chat/findConversation",
        }),
    },
    methods: {
        isClosedChat(contact) {
            return contact?.lastConversation?.status === "destroyed";
        },
        getChatOwnerStatus() {
            //return you,others,chatbot,queue,closed
            const isAssignedToMe = this.contact?.lastConversation?.users?.includes(this.user._id);
            const isAssignedToAnotherAgent = !isAssignedToMe && this.contact?.lastConversation?.users?.length > 0;
            const isClosed = this.contact?.lastConversation?.status === "destroyed";
            const isInQueue = this.contact?.lastConversation?.status === "new";
            const isInChatbot = this.contact?.lastConversation?.status === "chatbot";
            if (isClosed) {
                return "closed";
            } else if (isInQueue) {
                return "queue";
            } else if (isAssignedToMe) {
                return "you";
            } else if (isInChatbot) {
                return "chatbot";
            } else if (isAssignedToAnotherAgent) {
                return "others";
            } else {
                return "closed";
            }
        },
        getChatOwnerText() {
            if (this.contact?.lastConversation?.startedFrom === "api") {
                return "API ile  başlatıldı";
            } else if (this.contact?.lastConversation?.startedFrom === "broadcast") {
                return "Toplu mesaj ile başlatıldı";
            } else if (this.contact?.lastConversation?.startedFrom === "instagram-comment") {
                return "Instagram yorumu ile başlatıldı";
            } else if (this.contact?.lastConversation?.startedFrom === "instagram-mention") {
                return "Instagram mention ile başlatıldı";
            } else if (this.contact?.lastConversation?.startedFrom === "page-comment") {
                return "Facebook yorumu ile başlatıldı";
            } else if (this.contact?.lastConversation?.startedFrom === "automation") {
                return "Otomasyon ile başlatıldı";
            }
            if (this.contact?.lastConversation?.status === "new") {
                return "Temsilci bekleniyor";
            } else if (this.contact?.lastConversation?.status === "chatbot") {
                return "Chatbot ile görüşmede";
            } else if (this.contact?.lastConversation?.status === "active") {
                const users = this.contact.lastConversation?.users || [];
                const currentUser = this.user;
                const connectedUser = this.contact.lastConversation?.connectedUser;
                const allUsers = this.users;
                if (users.length === 0 && !connectedUser) {
                    return `Temsilci bekleniyor`;
                } else if (users.length === 1 && users[0] === currentUser._id) {
                    return "Seninle görüşmede";
                } else if (users.length === 1) {
                    const firstUser = allUsers.find((user) => user._id === users[0]);
                    return `${firstUser?.name} ile görüşmede`;
                } else if (users.length === 2) {
                    const firstUser = allUsers.find((user) => user._id === users[0]);
                    const secondUser = allUsers.find((user) => user._id === users[1]);
                    const isAssignedToMe = users.includes(currentUser._id);
                    if (isAssignedToMe) {
                        const otherUser = [firstUser, secondUser].find((user) => user?._id !== currentUser?._id);
                        return `Sen ve ${otherUser?.name}  ile görüşmede`;
                    } else {
                        return `${firstUser?.name} ve ${secondUser?.name}  ile görüşmede`;
                    }
                } else if (users.length > 1) {
                    let firstUser = allUsers.find((user) => user._id === users[0]);
                    const isAssignedToMe = users.includes(currentUser._id);
                    if (isAssignedToMe) {
                        firstUser = allUsers.find((user) => user._id === currentUser._id);
                    }
                    let firstUserName = firstUser ? firstUser.name : "Bilinmeyen";
                    if (isAssignedToMe) {
                        firstUserName = "Sen";
                    }
                    return `${firstUserName} ve ${users.length - 1} kişi ile görüşmede`;
                }
            } else if (this.contact?.lastConversation?.status === "destroyed") {
                const users = this.contact.lastConversation?.users || [];
                const connectedUser = this.contact.lastConversation?.connectedUser;
                const currentUser = this.user;
                const allUsers = this.users;
                if (users.length === 0 && !connectedUser) {
                    return `Kimse ilgilenmedi`;
                } else if (users.length === 0 && !!connectedUser) {
                    const firstUser = allUsers.find((user) => user._id === connectedUser);
                    return `Temsilci ${firstUser?.name} hattan düştü`;
                } else if (users.length === 1 && users[0] === currentUser._id) {
                    return "Seninle Görüştü";
                } else if (users.length === 1) {
                    const firstUser = allUsers.find((user) => user._id === users[0]);
                    return `${firstUser?.name} ile görüştü`;
                } else if (users.length > 1) {
                    const firstUser = allUsers.find((user) => user._id === users[0]);

                    const firstUserName = firstUser ? firstUser.name : "Bilinmeyen";
                    return `${firstUserName} ve ${users.length - 1} kişi ile görüştü`;
                }
            } else {
                return "";
            }
        },
        isGhost() {
            return !this.contact?._id;
        },
        fromNow() {
            // return duration < 60 ? "Just now"  other mm:ss
            const lastChatStatus = _.get(this.contact, "lastConversation.status", "destroyed");
            const isActive = ["new", "active", "chatbot"].includes(lastChatStatus);
            const createdDate = this.contactListSortMode.startsWith("chat.create")
                ? moment(this.contact?.lastConversation?.createdDate)
                : moment(this.contact.lastInteractionDate);
            const duration = moment.duration(moment().diff(createdDate));
            if (isActive && this.contactListSortMode.startsWith("chat.create")) {
                if (duration < 30000) return "Just now";
                else if (duration >= 1000 * 60 * 60) {
                    return moment.utc(duration.asMilliseconds()).format("HH:mm:ss");
                } else {
                    return moment.utc(duration.asMilliseconds()).format("mm:ss");
                }
            } else {
                const isToday = moment().isSame(createdDate, "day");
                const isYesterday = moment().subtract(1, "days").isSame(createdDate, "day");
                if (duration < 30000) return "Just now";
                else if (isToday) {
                    return moment(createdDate).format("LT");
                } else if (isYesterday) return "Yesterday";
                else {
                    return moment(createdDate).format("DD/MM/YYYY HH:mm");
                }
            }
        },
        getFullTime() {
            return this.contactListSortMode.startsWith("chat.create")
                ? moment(this.contact?.lastConversation?.createdDate).format("LLLL")
                : moment(this.contact.lastInteractionDate).format("LLLL");
        },
        isActive() {
            return this.contact && this.activeContact?._id === this.contact?._id;
        },
        clickConversation() {
            if (this.contact) this.$emit("joinConversation");
        },
        getUnreadCount() {
            const unread = this.contact.unreadedCount;
            return !!unread && (unread >= 100 ? "99+" : unread);
        },
        getFullname() {
            return SanitizeHtml(this.contact.fullname) || "N/A";
        },
        lastMessageIsAsset() {
            return !!this.$_.get(this.contact, `lastMessage.asset`);
        },
        lastMessageIsLocation() {
            return !!this.$_.get(this.contact, `lastMessage.location`);
        },
        getLastMessage() {
            const message = this.$_.get(this.contact, `lastMessage.description`, null);
            return message ? SanitizeHtml(message, true) : "";
        },
        getLastMessageSender() {
            return (
                this.$_.get(this.contact, `lastMessage.messageType`) ||
                this.$_.get(this.contact, `lastMessage.type`) ||
                null
            );
        },
        resetInterval() {
            if (this.dateInterval) clearInterval(this.dateInterval);
            this.dateInterval = null;
        },
        setupInterval() {
            if (!this.contact) return;
            this.dateInterval = setInterval(() => {
                this.dateRenderKey++;
            }, 1000);
        },
    },
    watch: {
        contact: {
            deep: true,
            handler() {
                if (this.dateInterval) this.resetInterval();
                this.setupInterval();
            },
        },
    },
    beforeDestroy() {
        this.resetInterval();
    },
};
</script>
<style lang="scss">
@keyframes ghostAnimation {
    0% {
        transform: rotate(45deg) translate(-20%, 300%);
        transition: all 0.4s;
    }
    100% {
        transform: rotate(45deg) translate(-20%, -150%);
        transition: all 0.4s;
    }
}

.conversation-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 1px 5px;
    border-radius: 5px;
    cursor: pointer;
    overflow: hidden;
    height: 70px;
    max-height: 70px;
    min-height: 70px;
    position: relative;
    border-bottom: 2px solid #f2f4f7;

    &.unreaded {
        .contact-detail-content {
            font-weight: bold;
        }
    }

    &.ghost {
        background: var(--color-bg-neutral-default);

        &:after {
            background: #fff;
            bottom: 0;
            content: "";
            height: 100%;
            left: -10%;
            opacity: 0.3;
            position: absolute;
            top: 0;
            transform: rotate(45deg) translate(-20%, 300%);
            width: 160%;
            animation: ghostAnimation 2s infinite;
        }
    }

    &.active {
        background: var(--color-bg-neutral-default);
    }

    &:hover {
        background: var(--color-bg-neutral-default);
    }

    .minimize-card-detail {
        width: 100%;
        display: flex;
        gap: 15px;
        height: 100% !important;

        .conversation-contact-avatar {
            position: relative;

            .contact-platform {
                position: absolute;
                bottom: 17px;
                right: -2px;
                display: flex;
                align-items: center;
                background: white;
                border-radius: 20px;
                padding: 3px;
            }
        }

        .contact-detail {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 4px;
            overflow: hidden;

            .chat-owner-text {
                font-size: 11px;
                font-weight: 600;
                text-align: right;
                color: #754cd5;
                width: 100%;
                -webkit-line-clamp: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                &.you {
                    color: #32cd32;
                }

                &.others {
                    color: #ffa500;
                }

                &.chatbot {
                    color: #87ceeb;
                }

                &.queue {
                    color: #9370db;
                }

                &.closed {
                    color: #d3d3d3;
                }
            }

            .contact-detail-head {
                display: flex;
                justify-content: space-between;
                width: 100%;
                overflow: hidden;
                align-items: center;

                .contact-information {
                    font-weight: bold;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }

                .contacted-date {
                    white-space: nowrap;

                    .time-label {
                        display: flex;
                        align-items: center;
                        gap: 2px;

                        .material-icons {
                            font-size: 16px;
                            color: #647491;
                        }
                    }
                }
            }

            .contact-detail-content {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;

                .contact-detail-content-message {
                    display: flex !important;
                    align-items: center;
                    gap: 2px;
                    overflow: hidden;

                    .icon-wrapper {
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .material-icons {
                            font-size: 20px;
                            color: #647491;
                        }
                    }

                    .contact-last-message {
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;

                        &.media {
                            display: flex;
                            align-items: center;
                            gap: 2px;

                            .material-icons {
                                font-size: 20px;
                            }
                        }
                    }
                }

                .unread-badge {
                    background: #eee7ff;
                    font-size: 10px;
                    min-width: 30px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 15px;
                    font-weight: bold;
                }
            }
        }
    }
}
</style>
